'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _excluded = ["src", "checkForExisting", "shouldLoad"];

/**
 * useScript
 *
 * Hook used to asynchronously load a script into the DOM.
 */
var useScript = function useScript(_ref) {
  var src = _ref.src,
    _ref$checkForExisting = _ref.checkForExisting,
    checkForExisting = _ref$checkForExisting === void 0 ? true : _ref$checkForExisting,
    _ref$shouldLoad = _ref.shouldLoad,
    shouldLoad = _ref$shouldLoad === void 0 ? function () {
      return true;
    } : _ref$shouldLoad,
    attributes = _objectWithoutProperties__default["default"](_ref, _excluded);
  var _useState = React.useState(true),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = React.useState(null),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var scriptShouldBeLoaded = shouldLoad();
  var handleLoad = function handleLoad() {
    setLoading(false);
  };
  var handleError = function handleError(err) {
    setError(err);
  };
  React.useEffect(function () {
    if (!scriptShouldBeLoaded) {
      setLoading(false);
      return;
    }
    if (checkForExisting) {
      var existing = document.querySelectorAll("script[src=\"".concat(src, "\"]"));
      if (existing.length > 0) {
        setLoading(false);
        return;
      }
    }

    // Create script & append to body
    var script = document.createElement('script');
    script.setAttribute('src', src);
    Object.keys(attributes).forEach(function (key) {
      if (script[key] === undefined) {
        script.setAttribute(key, attributes[key]);
      } else {
        script[key] = attributes[key];
      }
    });
    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);
    document.body.appendChild(script);

    // eslint-disable-next-line consistent-return
    return function () {
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };
  }, [src, scriptShouldBeLoaded]);
  return [loading, error];
};
exports["default"] = useScript;